export default {
    title: 'AI Model Configuration',
    permissionAlert: 'This page can only be modified by admins. API Keys are encrypted and managed by system admins in the backend; this page only controls business-side toggles and model selection.',
    providerSection: 'General Model Configuration',
    imageModelSection: 'Image Model Configuration',
    taskSection: 'Task Model Assignment',
    taskDesc: 'Assign models to different AI tasks',
    usageSection: 'Usage Statistics (This Month)',
    connected: '● Connected',
    notConnected: '○ Not Connected',
    connectionStatus: 'Connection Status',
    errorStatus: 'Error',
    unknownStatus: 'Unknown',
    errorHint: 'API connection error, please contact system admin',
    connectedStatus: 'Connected',
    notConnectedStatus: 'Not Connected',
    availableModels: 'Available Models',
    checkHint: 'Checked models can be used in AI tasks',
    notConnectedHint: 'Contact system admin to complete API integration',
    recommended: 'Recommended',
    adminOnlyTooltip: 'Admin only',
    toggleFailed: 'Operation failed, please try again',
    saveOk: 'Configuration saved',
    noModels: 'No models available yet',
    modelConfigNotFound: 'Model configuration not found, please refresh and try again',
    configServiceUnavailable: 'AI configuration service is unavailable, please try again later',
    provider: {
      anthropic: 'Anthropic (Claude)',
      openai: 'OpenAI (GPT)',
      google: 'Google (Gemini)',
    },
    task: {
      name: 'Task',
      desc: 'Description',
      primary: 'Primary Model',
      backup: 'Backup Model',
      noBackup: 'No Backup',
      random: 'Round Robin',
      primaryRequired: 'Please configure the primary model first',
      articleGen: '📝 Article Generation',
      articleGenDesc: 'Full article + FAQ + Meta',
      keywordMining: '🔑 Keyword Mining',
      keywordMiningDesc: 'AI keyword discovery',
      scoring: 'SEO/GEO Score',
      scoringDesc: 'AI-assisted scoring',
    },
    usage: {
    title: 'AI Usage Stats (This Month)',
    callCount: 'API Calls',
    totalTokens: 'Token Usage',
    cost: 'Monthly Cost',
    dataSourceStub: 'Data is placeholder, pending ES integration',
    byModelTitle: 'By Model',
    modelName: 'Model',
    provider: 'Provider',
    callCountCol: 'Calls',
    costCol: 'Cost (USD)',
  },
    backupHint: '✓ Backup Model: automatically switches to backup when primary fails (rate limit / insufficient balance / timeout). Daily Limit: pauses the task when the daily call count is reached to prevent runaway costs.',
};
